/* eslint-disable */
import * as util from '../../assets/common/util.js'
// import * as hqUtil from '../../assets/js/hq/hqUtil.js'
// import { stat } from "fs";

const state = {
  currentSellTop: null, //0
  currentBuyTop: null,//0
  selectHighPrice: null,
  selectLowPrice: null,
  selectNewPrice: null,
  marketid: 0,
  openTime: 0,
  closeTime: 0,
  currentContractId: 0,
  timeLineData: [],
  kLineData: [],
  marketDetails: [],
  item: {},
  pricedetail: {},
  buyLst: [],
  sellLst: [],
  buyOrderLst: [],
  sellOrderLst: [],
  buyOne: [],
  sellOne: [],
  buyMaxAmount: 0,
  sellMaxAmount: 0,
  // 2021-12-21新增 筛选实时成交信息
  pricedetail_big: {},
  // 挂牌
  lstMarketDetails: [],
  currencyData: {},
  pricedetailNon: {},
  PushPriceDetailResponseBuy: {},
  PushPriceDetailResponseSell: {},
  currentCommodityInfo: {},
  // 中远期
  marketidMid: 0,
  openTimeMid: 0,
  closeTimeMid: 0,
  currentContractIdMid: 0,
  timeLineDataMid: [],
  kLineDataMid: [],
  marketDetailsMid: [],
  itemMid: {},
  hqPricedetailMid: {},
  buyLstMid: [],
  sellLstMid: [],
  buyOneMid: [],
  sellOneMid: [],
  currencyDataMid: {},
  // 可展示的商品id列表 (登录后生效)
  queryUserAccessArr: [],
  // 可展示的商品列表 (登录后生效)
  queryTradeAuthArr: [],
  // 挂牌合约详情
  commodityParamList: [],
  tvReadyFlags: false, // tv刷新状态
  /**top点击 start */
  // 当点击top触发更新
  topCLickNum: 0,
  // 标注top点击的买卖方向和级别
  topClickInfo: {
    type: 'buy', // buy/sell
    l: 0 // top1:0
  },
  commodityStrategy:[],//商品信息
  /**top点击 end */
  BusinessDetail:[],//行情简报
  orderBad: 0, // 委差
  orderRate: 0, // 委比 --- 茶交易新增
  qrr: 0, // 量比 --- 茶交易新增
  qrrId: 0, // 量比返回时的商品id --- 茶交易新增
  ysList: []// 优选商品列表
}

// getters
const getters = {
  commodityStrategyGetter: state => state.commodityStrategy ,
  currentBuyTopGetter: state => state.currentBuyTop,
  currentSellTopGetter: state => state.currentSellTop,
  selectHighPriceGetter: (state) => {
    return state.selectHighPrice
  },
  selectLowPriceGetter: (state) => {
      return state.selectLowPrice
  },
  selectNewPriceGetter: (state) => {
      return state.selectNewPrice
  },
  topClickInfo: (state) => {
    return state.topClickInfo
  },
  topCLickNum: (state) => {
    return state.topCLickNum
  },
  tvReadyFlagsGetter: (state) => {
    return state.tvReadyFlags
  },
  item: (state) => {
    // const itemData = state.item
    var arr = Object.keys(state.item)
    if (arr.length !== 0 && state.marketDetails && state.marketDetails.length > 0) {
        for (let i = 0; i < state.marketDetails.length; i++) {
            const element = state.marketDetails[i]
                /* eslint-disable */
            if (element.symbolId == state.item.symbolId) {
                return element
            }
        }
        return state.item
    } else {
      // 默认展示优选商品的第一个 ysList
        if (state.ysList.length) {
          let n = 0
          for (let i = 0; i < state.marketDetails.length; i++) {
            if (state.marketDetails[i].symbolId == state.ysList[0]) {
              const obj = state.marketDetails[i]
              return obj
            } else {
              n++
            }
            if (n==state.ysList.length) {
              const obj = state.marketDetails[0]
              return obj
            }
          }
        } else {
          const obj = state.marketDetails[0]
          return obj
        }
        
    }
  },
  ysList(state){
    return state.ysList
  },
  buyLst(state) {
    const itemData = state.buyLst.slice()
    return itemData
  },
  sellLst(state) {
    const itemData = state.sellLst.slice()
    return itemData
  },
  buyOrderLst(state) {
    const itemData = state.buyOrderLst.slice()
    return itemData
  },
  sellOrderLst(state) {
    const itemData = state.sellOrderLst.slice()
    return itemData
  },
  buyMaxAmount: (state) => {
    return state.buyMaxAmount
  },
  sellMaxAmount: (state) => {
    return state.sellMaxAmount
  },
  orderBad: (state) => {
    return state.orderBad
  },
  orderRate: (state) => {
      return state.orderRate
  },
  qrr: (state) => {
      return state.qrr
  },
  qrrId: (state) => {
      return state.qrrId
  },
  pricedetail: (state) => {
    const pricedetailData = state.pricedetail.currentDataArray
    return pricedetailData
  },
  pricedetail_big: (state) => { // 大单筛选
    const pricedetailData = state.pricedetail_big.currentDataArray
    return pricedetailData
  },
  marketDetails: (state) => {
    for (let i = 0; i < state.marketDetails.length; i++) {
      const str = state.marketDetails[i].quotechange
      const zf = str.substring(0, 1)
      if (zf == '-') {
        state.marketDetails[i].quotechangeColor = '#41b37d'
      } else {
        state.marketDetails[i].quotechangeColor = '#d74e5a'
      }
      if(str=='0.00%'){
        state.marketDetails[i].quotechangeColor = '#b0b8db'
      }

      // 最新价。最新价和昨结价对比，高于昨结价展示红色、等于昨结价展示白色、低于展示绿色。
      let close = state.marketDetails[i].close // 最新价
      let clearPrice = state.marketDetails[i].clearPrice // 昨结价
      state.marketDetails[i].closeToClearColor = '#b0b8db'
      if (typeof(close)==='number' && typeof(clearPrice)==='number'){
        if (close > clearPrice) {
          state.marketDetails[i].closeToClearColor = '#d74e5a'
        }
        if (close < clearPrice) {
          state.marketDetails[i].closeToClearColor = '#41b37d'
        }
      }

    }
    return state.marketDetails.slice()
  },

  sellOne(state) {
    const itemData = state.sellOne
    return itemData
  },
  buyOne(state) {
    const itemData = state.buyOne
    return itemData
  },
  // 挂牌
  lstMarketDetails: (state) => {
    const aLst = state.lstMarketDetails
    const aLstData = []
    const arr = []
    // 取出mdMap(按币种区分的买卖)数据
    for (let i = 0; i < aLst.length; i++) {
      aLst[i].mdMap.b.sId = aLst[i].contractId
      aLst[i].mdMap.s.sId = aLst[i].contractId
      aLstData.push(aLst[i].mdMap)
    }
    // 把单个买卖数据插入数组
    for (let j = 0; j < aLstData.length; j++) {
      const oB = aLstData[j].b
      const oS = aLstData[j].s
      arr.push(oB, oS)
    }
    // 判断买卖涨跌并把样式赋到对象中
    for (let i = 0; i < arr.length; i++) {
      const sSign = arr[i].quotechange
      sSign.indexOf('-') == '-1'
        ? (arr[i].quotechangeColor = '#d74e5a')
        : (arr[i].quotechangeColor = '#41b37d')
      // arr[i].starIcon = "el-icon-star-off";
      if (arr[i].bsFlag == 'B') {
        arr[i].flag = '摘牌'
      } else if (arr[i].bsFlag == 'S') {
        arr[i].flag = '挂牌'
      }
    }
    // 输出数据
    return arr
  },
  pricedetailNon: (state) => {
    let pricedetailData = [].concat(state.pricedetailNon.currentDataArray)
    pricedetailData = pricedetailData.slice(0, 500)
    return pricedetailData
  },
  currencyData: (state) => {
    const itemData = state.currencyData
    return itemData
  },
  // timeLine、KLine
  timeLineDataGetter: (state) => {
    return state.timeLineData
  },
  kLineDataGetter: (state) => {
    return state.kLineData
  },
  currentCommodityInfoGetter: (state) => {
    return state.currentCommodityInfo
  },
  // 中远期
  currencyDataMid: (state) => {
    const itemData = state.currencyDataMid
    return itemData
  },
  currentCommodityInfoMidGetter: (state) => {
    return state.currentCommodityInfoMid
  },
  itemMid: (state) => {
    const itemData = state.itemMid
    return itemData
  },
  buyLstMid(state, data) {
    const itemData = state.buyLstMid.slice()
    return itemData
  },
  sellLstMid(state, data) {
    const itemData = state.sellLstMid.slice()
    return itemData
  },

  hqPricedetailMid: (state) => {
    const pricedetailData = state.hqPricedetailMid.currentDataArray
    return pricedetailData
  },
  marketDetailsMid: (state) => {
    for (let i = 0; i < state.marketDetailsMid.length; i++) {
      const str = state.marketDetailsMid[i].quotechange
      const zf = str.substring(0, 1)
      if (zf == '-') {
        state.marketDetailsMid[i].quotechangeColor = '#41b37d'
      } else {
        state.marketDetailsMid[i].quotechangeColor = '#d74e5a'
      }
      if(str=='0.00%'){
        state.marketDetailsMid[i].quotechangeColor = '#b0b8db'
      }
    }
    return state.marketDetailsMid.slice()
  },

  sellOneMid(state, data) {
    const itemData = state.sellOneMid
    return itemData
  },
  buyOneMid(state, data) {
    const itemData = state.buyOneMid
    return itemData
  },
  queryUserAccessArrGetter(state) {
    return state.queryUserAccessArr
  },
  queryTradeAuthArrGetter(state) {
    return state.queryTradeAuthArr
  },
  commodityParamListGetter: (state) => {
    return state.commodityParamList
  },
  BusinessDetailGetter: (state) => {
    return state.BusinessDetail
  }
}

// actions
const actions = {
  initDataContract(state, data) {
    state.contract = ['...data']
  },
  initMarketid(state, data) {
    state.marketid = data
  },
  pricedetailNon(state, data) {
    state.pricedetailNon = data
  }
}

// mutations
const mutations = {
  ysList(state, data) {
    state.ysList = data
  },
  currentBuyId(state, data) {
    state.currentBuyTop = data
  },
  currentSellId(state, data) {
    state.currentSellTop = data
  },
  setSelectHighPrice(state, data) {
    state.selectHighPrice = data
  },
  setSelectLowPrice(state, data) {
      state.selectLowPrice = data
  },
  setSelectNewPrice(state, data) {
      state.selectNewPrice = data
  },
  orderBad(state, data) {
    state.orderBad = data
  },
  orderRate(state, data) {
      state.orderRate = data
  },
  qrr(state, data) {
      state.qrr = data
  },
  qrrId(state, data) {
      state.qrrId = data
  },
  setCommodityStrategy(state, data) {
    state.commodityStrategy = data
    if (state.marketDetails.length > 0 && data.length > 0) {
      for (const j in state.marketDetails) {
          for (const item of state.commodityStrategy) {
              let n = 0
              if (Number(state.marketDetails[j].symbolId) === Number(item.commodityId)) {
                // const minPriceChange = item.minPriceChange // 最小数量变动单位
                // const minAmountChange = item.minAmountChange // 价格价格变动单位
                // let pricePoint = -Math.round(Math.log(minPriceChange) / Math.log(10))
                // let amountPoint = -Math.round(Math.log(minAmountChange) / Math.log(10))
                let pricePoint = 0
                let amountPoint = 0
                if (String(item.minPriceChange).indexOf('.') !== -1) {
                    const dotNum = String(item.minPriceChange).indexOf('.') + 1 // 获取小数点的位置
                    pricePoint = String(item.minPriceChange).length - dotNum // 获取小数点后的个数
                }
                if (String(item.minAmountChange).indexOf('.') !== -1) {
                    const dotNum = String(item.minAmountChange).indexOf('.') + 1 // 获取小数点的位置
                    amountPoint = String(item.minAmountChange).length - dotNum // 获取小数点后的个数
                }
                if (pricePoint <= 0) {
                  pricePoint = 0
                }
                if (amountPoint <= 0) {
                  amountPoint = 0
                }
              state.marketDetails[j].numStr = new RegExp('^(\\d+)\\.(\\d{0,' + pricePoint + '}).*$')
              state.marketDetails[j].coinDigitalNum = pricePoint
              state.marketDetails[j].quantityNum = amountPoint
              state.marketDetails[j].quantityStr = new RegExp('^(\\d+)\\.(\\d{0,' + amountPoint + '}).*$')// 数量
              } else {
                  n++
                  if (n === state.commodityStrategy.length) {
                      state.marketDetails[j].numStr =/^(\d+)\.(\d{0,2}).*$/
                      state.marketDetails[j].coinDigitalNum = 2
                      state.marketDetails[j].quantityNum = 2 // 数量
                      state.marketDetails[j].quantityStr =/^(\d+)\.(\d{0,2}).*$/ // 数量
                  }
              }
          }
      
      }
  }
  },
  setBusinessDetail(state, data) {
    state.BusinessDetail = data
  },
  topCLickNum(state, data) {
    state.topCLickNum++
  },
  topClickInfo(state, data) {
    state.topClickInfo = data
  },
  setTvReadyFlags(state, data) {
    state.tvReadyFlags = data
    // state.items = data;
    // state.itemsEnd = data;
  },
  item(state, data) {
    state.item = data
    // state.items = data;
    // state.itemsEnd = data;
  },
  sellMaxAmount(state, data) {
    state.sellMaxAmount = data
  },
  buyMaxAmount(state, data) {
    state.buyMaxAmount = data
  },
  updateMarketDetails(state, data) {
    state.marketDetails = [...data]
    if (state.commodityStrategy.length > 0 && data.length > 0) {
      for (const j in data) {
          for (const item of state.commodityStrategy) {
              let n = 0
              if (Number(state.marketDetails[j].symbolId) === Number(item.commodityId)) {
                // const minPriceChange = item.minPriceChange // 最小数量变动单位
                // const minAmountChange = item.minAmountChange // 价格价格变动单位
                // let pricePoint = -Math.round(Math.log(minPriceChange) / Math.log(10))
                // let amountPoint = -Math.round(Math.log(minAmountChange) / Math.log(10))
                let pricePoint = 0
                let amountPoint = 0
                if (String(item.minPriceChange).indexOf('.') !== -1) {
                    const dotNum = String(item.minPriceChange).indexOf('.') + 1 // 获取小数点的位置
                    pricePoint = String(item.minPriceChange).length - dotNum // 获取小数点后的个数
                }
                if (String(item.minAmountChange).indexOf('.') !== -1) {
                    const dotNum = String(item.minAmountChange).indexOf('.') + 1 // 获取小数点的位置
                    amountPoint = String(item.minAmountChange).length - dotNum // 获取小数点后的个数
                }
                if (pricePoint <= 0) {
                  pricePoint = 0
                }
                if (amountPoint <= 0) {
                  amountPoint = 0
                }
              state.marketDetails[j].numStr = new RegExp('^(\\d+)\\.(\\d{0,' + pricePoint + '}).*$')
              state.marketDetails[j].coinDigitalNum = pricePoint
              state.marketDetails[j].quantityNum = amountPoint
              state.marketDetails[j].quantityStr = new RegExp('^(\\d+)\\.(\\d{0,' + amountPoint + '}).*$')// 数量
              } else {
                  n++
                  if (n === state.commodityStrategy.length) {
                      state.marketDetails[j].numStr = /^(\d+)\.(\d{0,2}).*$/
                      state.marketDetails[j].coinDigitalNum = 2
                      state.marketDetails[j].quantityNum = 2 // 数量
                      state.marketDetails[j].quantityStr =/^(\d+)\.(\d{0,2}).*$/ // 数量
                  }
              }
            }
         
      }
    }
    if(state.commodityStrategy.length == 0){
      for (const j in data) {
        state.marketDetails[j].numStr = /^(\d+)\.(\d{0,2}).*$/
        state.marketDetails[j].coinDigitalNum = 2
        state.marketDetails[j].quantityNum = 2 // 数量
        state.marketDetails[j].quantityStr =/^(\d+)\.(\d{0,2}).*$/ // 数量 
      }
    }
  },
  pricedetail(state, data) {
    state.pricedetail = data
  },
  pricedetail_big(state, data) {
    state.pricedetail_big = data
  },
  clearPriceDetail(state, data) {
    state.pricedetail.currentDataArray = []
  },
  clearPriceDetail_big(state, data) {
    state.pricedetail_big.currentDataArray = []
  },
  updateCurrentContractId(state, data) {
    state.currentContractId = 111000017
  },
  updateTimeLineData(state, data) {
    state.timeLineData = [...data]
  },
  updateKLineData(state, data) {
    state.kLineData = [...data]
  },
  updatemarketid(state) {
    state.marketid = 1
  },
  updateOpenCloseTime(state, openTime, closeTime) {
    state.openTime = openTime
    state.closeTime = closeTime
  },
  updatemarketid(state) {
    state.marketid = 1
  },
  buyLst(state, data) {
    state.buyLst = data
  },
  sellLst(state, data) {
    state.sellLst = data
  },
  buyOrderLst(state, data) {
    state.buyOrderLst = data
  },
  sellOrderLst(state, data) {
    state.sellOrderLst = data
  },
  PushPriceDetailResponse(state, data) {
    for (const j in data) {
      if (data.hasOwnProperty(j)) {
        const pushData = data[j]
        const newpricedetail = {}
        newpricedetail.price = pushData.price // 价格
        newpricedetail.volume = pushData.volume // 成交量
        newpricedetail.ioFlag = pushData.ioFlag // 买卖方向 0 买 1 卖
        newpricedetail.quote = Number(util.floatSub(pushData.price,pushData.sellPrice)).toFixed(0) // 买卖方向 0 买 1 卖
        newpricedetail.occurTime = pushData.occurTime
        newpricedetail.tradeDate = '0'
        newpricedetail.contractId = pushData.contractId // 币种id
        newpricedetail.marketID = '0'
        newpricedetail.averagePrice = '0'
        newpricedetail.buyPrice = '0'
        newpricedetail.sellPrice = '0'
        newpricedetail.tickCount = '0'
        newpricedetail.itemNum = '0'
        newpricedetail.counter = '0'
        // 现量
        newpricedetail.currencyQuantity = pushData.currencyQuantity
        // // 订货量
        // newpricedetail.holdQuantity = pushData.holdQuantity
        // // 仓差
        // newpricedetail.warehouseBad = pushData.warehouseBad
        // 换手率
        // newpricedetail.turnoverRate = pushData.turnoverRate
        if (state.pricedetail && state.pricedetail.currentDataArray && state.pricedetail.contractId==newpricedetail.contractId) {
          const arrnum = state.pricedetail.currentDataArray.unshift(
            newpricedetail
          )
          if (arrnum >= 30000) {
            state.pricedetail.currentDataArray.pop()
          }
        }
        state.marketDetails.find((v, i) => {
          if (v.symbolId == pushData.contractId) {
            let key = i
            state.marketDetails[key].amount = pushData.allVolume
            state.marketDetails[key].close = pushData.price
            state.marketDetails[key].high = pushData.highPrice
            state.marketDetails[key].low = pushData.lowPrice
            state.marketDetails[key].quotechange = pushData.qc
            state.marketDetails[key].quote = Number(util.floatSub(pushData.price,pushData.sellPrice)).toFixed(2)
            state.marketDetails[key].averagePrice = pushData.averagePrice
            state.marketDetails[key].totalAmount = pushData.totalAmount
            state.marketDetails[key].open = pushData.openPrice
            // state.marketDetails[key].turnoverRate = pushData.turnoverRate // 换手率
            state.marketDetails[key].currencyQuantity = pushData.currencyQuantity // 现量
            state.marketDetails[key].buyCount = pushData.buyCount // 外盘
            state.marketDetails[key].sellCount = pushData.sellCount // 内盘
            // state.marketDetails[key].currencyQuantity = pushData.volume // 现量 currencyQuantity  volume两个值相同
            // state.marketDetails[key].holdQuantity = pushData.holdQuantity // 订货量
            // state.marketDetails[key].warehouseBad = pushData.warehouseBad // 仓差
            return
          }
        })
      }
    }
  },
  PushHoldResponse(state, data) {
    const pushData = data
    state.marketDetails.find((v, i) => {
      if (v.symbolId == pushData.contractId) {
        let key = i
        // state.marketDetails[key].amount = pushData.allVolume
        // state.marketDetails[key].close = pushData.price
        // state.marketDetails[key].high = pushData.highPrice
        // state.marketDetails[key].low = pushData.lowPrice
        // state.marketDetails[key].quotechange = pushData.qc
        // state.marketDetails[key].quote = Number(util.floatSub(pushData.price,pushData.sellPrice)).toFixed(0)
        // state.marketDetails[key].averagePrice = averagePrice
        // state.marketDetails[key].totalAmount = pushData.totalAmount
        // state.marketDetails[key].open = pushData.openPrice
        state.marketDetails[key].turnoverRate = pushData.turnoverRate // 换手率
        // state.marketDetails[key].currencyQuantity = pushData.currencyQuantity // 现量
        state.marketDetails[key].holdQuantity = pushData.holdQuantity // 订货量
        state.marketDetails[key].warehouseBad = pushData.warehouseBad // 仓差
        // state.marketDetails[key].open == 0 ? state.marketDetails[key].open = pushData.price : state.marketDetails[key].open = state.marketDetails[key].open
        return
      }
    })
  },
  PushPriceDetailResponse_big(state, data) { // 大单筛选
    for (const j in data) {
      if (data.hasOwnProperty(j)) {
        const pushData = data[j]
        const newpricedetail = {}
        newpricedetail.price = pushData.price // 价格
        newpricedetail.volume = pushData.volume // 成交量
        newpricedetail.ioFlag = pushData.ioFlag // 买卖方向 0 买 1 卖
        newpricedetail.quote = Number(util.floatSub(pushData.price,pushData.sellPrice)).toFixed(0) // 买卖方向 0 买 1 卖
        newpricedetail.occurTime = pushData.occurTime
        newpricedetail.tradeDate = '0'
        newpricedetail.contractId = pushData.contractId // 币种id
        newpricedetail.marketID = '0'
        newpricedetail.averagePrice = '0'
        newpricedetail.buyPrice = '0'
        newpricedetail.sellPrice = '0'
        newpricedetail.tickCount = '0'
        newpricedetail.itemNum = '0'
        newpricedetail.counter = '0'
        // 现量
        newpricedetail.currencyQuantity = pushData.currencyQuantity
        // 订货量
        // newpricedetail.holdQuantity = pushData.holdQuantity
        // 仓差
        // newpricedetail.warehouseBad = pushData.warehouseBad
        // 换手率
        // newpricedetail.turnoverRate = pushData.turnoverRate
        if (state.pricedetail && state.pricedetail.currentDataArray && state.pricedetail.contractId==newpricedetail.contractId) {
          const arrnum = state.pricedetail.currentDataArray.unshift(
            newpricedetail
          )
          if (arrnum >= 30000) {
            state.pricedetail.currentDataArray.pop()
          }
        }
      }
    }
  },
  buyOne(state, data) {
    state.buyOne = data
  },
  sellOne(state, data) {
    state.sellOne = data
  },
  // 挂牌
  updateMarketDetailsNon(state, payload) {
    state.lstMarketDetails = [...payload]
    const a = Object.keys(state.currentCommodityInfo)
    if (Object.keys(state.currentCommodityInfo).length === 0) {
      if (
        state.lstMarketDetails &&
        state.lstMarketDetails.length > 0 &&
        state.lstMarketDetails[0].mdMap
      ) {
        const obj = state.lstMarketDetails[0].mdMap
        for (const objItem in obj) {
          const zf = obj[objItem].quotechange.substring(0, 1)
          if (zf == '+') {
            obj[objItem].bgColor = '#41b37d'
          } else {
            obj[objItem].bgColor = 'green'
          }
          obj[objItem].baseCurrency = obj[objItem].symbol.split('/')[0]
          obj[objItem].priceCurrency = obj[objItem].symbol.split('/')[1]
          if (obj[objItem].bsFlag === 'B') {
            state.currentCommodityInfo = obj[objItem]
          }
        }
      }
    }
  },
  currencyData(state, data) {
    state.currencyData = data
    state.currentCommodityInfo = data
    // state.items = data;
    // state.itemsEnd = data;
  },
  setTimeLineData(state, data) {
    state.timeLineData = [...data]
  },
  setKLineData(state, data) {
    state.kLineData = [...data]
  },
  pricedetailNon(state, data) {
    state.pricedetailNon = data
  },
  updateTimeLineDataNon(state, data) {
    if (data.type === 'push') {
      state.timeLineData.push(data)
    } else {
      state.timeLineData[state.timeLineData.length - 1].contractId =
        data.contractId
      state.timeLineData[state.timeLineData.length - 1].price = data.price
    }
  },
  updateKLineDataNon(state, data) {
    if (data.type === 'push') {
      data.highestPrice = data.closePrice
      data.lowestPrice = data.closePrice
      data.closePrice = data.closePrice
      data.openPrice = data.closePrice
      state.kLineData.push(data)
    } else {
      if (
        Number(state.kLineData[state.kLineData.length - 1].lowestPrice) >
        Number(data.closePrice)
      ) {
        state.kLineData[state.kLineData.length - 1].lowestPrice =
          data.closePrice
      }
      if (
        Number(state.kLineData[state.kLineData.length - 1].highestPrice) <
        Number(data.closePrice)
      ) {
        state.kLineData[state.kLineData.length - 1].highestPrice =
          data.closePrice
      }
      state.kLineData[state.kLineData.length - 1].closePrice = data.closePrice
    }
  },
  PushPriceDetailResponseBuy(state, data) {
    if (data) {
      const sId = data.symbolId
      if (state.lstMarketDetails.length > 0) {
        const sIdMarket = state.lstMarketDetails[0].contractId
        const buyPricedetail = data
        buyPricedetail.price = data.buyPrice
        buyPricedetail.ioFlag = 0
        buyPricedetail.occurTime = data.updateTime
        state.PushPriceDetailResponseBuy = data
        if (state.currencyData.symbolId) {
          if (state.currencyData.symbolId == sId) {
            const nonarrnum = state.pricedetailNon.currentDataArray.unshift(
              buyPricedetail
            )
            if (nonarrnum > 300) {
              state.pricedetailNon.currentDataArray.pop()
            }
          }
        } else {
          if (sId == sIdMarket) {
            state.pricedetailNon.currentDataArray
              ? state.pricedetailNon.currentDataArray.unshift(buyPricedetail)
              : state.pricedetailNon.currentDataArray
            // state.pricedetailNon.currentDataArray.unshift(buyPricedetail);
            if (
              state.pricedetailNon.currentDataArray &&
              state.pricedetailNon.currentDataArray.length > 300
            ) {
              state.pricedetailNon.currentDataArray.pop()
            }
          }
        }
        for (const key in state.lstMarketDetails) {
          if (state.lstMarketDetails.hasOwnProperty(key)) {
            const marketDetail = state.lstMarketDetails[key]
            if (buyPricedetail.symbolId == marketDetail.contractId) {
              state.lstMarketDetails[key].mdMap.b.amount = util.exactPointTwo(
                buyPricedetail.amount
              )
              state.lstMarketDetails[key].mdMap.b.buyPrice = util.exactPointTwo(
                buyPricedetail.buyPrice
              )
              state.lstMarketDetails[
                key
              ].mdMap.b.sellPrice = util.exactPointTwo(
                buyPricedetail.sellPrice
              )
              state.lstMarketDetails[key].mdMap.b.close = util.exactPointTwo(
                buyPricedetail.close
              )
              state.lstMarketDetails[key].mdMap.b.high = util.exactPointTwo(
                buyPricedetail.high
              )
              state.lstMarketDetails[key].mdMap.b.low = util.exactPointTwo(
                buyPricedetail.low
              )
              state.lstMarketDetails[key].mdMap.b.quotechange =
                buyPricedetail.quotechange
              state.lstMarketDetails[key].mdMap.b.changePrice =
                buyPricedetail.changePrice
              state.lstMarketDetails[key].mdMap.b.open = util.exactPointTwo(
                buyPricedetail.open
              )
              state.lstMarketDetails[
                key
              ].mdMap.b.yesterClosePrice = util.exactPointTwo(
                buyPricedetail.yesterClosePrice
              )
              state.lstMarketDetails[key].mdMap.b.updateTime =
                buyPricedetail.updateTime
            }
          }
        }
      }
    }
  },
  PushPriceDetailResponseSell(state, data) {
    if (data) {
      const sId = data.symbolId
      if (state.lstMarketDetails.length > 0) {
        const sIdMarket = state.lstMarketDetails[0].contractId
        const sellPricedetail = data
        sellPricedetail.price = data.sellPrice
        sellPricedetail.ioFlag = 1
        sellPricedetail.occurTime = data.updateTime
        state.PushPriceDetailResponseSell = data
        if (state.currencyData.symbolId) {
          if (state.currencyData.symbolId == sId) {
            const nonsellarrnum = state.pricedetailNon.currentDataArray.unshift(
              sellPricedetail
            )
            if (nonsellarrnum > 300) {
              state.pricedetailNon.currentDataArray.pop()
            }
          }
        } else {
          if (sId == sIdMarket) {
            state.pricedetailNon.currentDataArray
              ? state.pricedetailNon.currentDataArray.unshift(sellPricedetail)
              : state.pricedetailNon.currentDataArray
            if (
              state.pricedetailNon.currentDataArray &&
              state.pricedetailNon.currentDataArray.length > 300
            ) {
              state.pricedetailNon.currentDataArray.pop()
            }
          }
          // state.pricedetailNon.currentDataArray.unshift(sellPricedetail);
        }
        // state.pricedetail.currentDataArray.unshift(sellPricedetail);
        for (const key in state.lstMarketDetails) {
          if (state.lstMarketDetails.hasOwnProperty(key)) {
            const lstMarketDetails = state.lstMarketDetails[key]
            if (sellPricedetail.symbolId == lstMarketDetails.contractId) {
              state.lstMarketDetails[key].mdMap.s.amount = util.exactPointTwo(
                sellPricedetail.amount
              )
              state.lstMarketDetails[key].mdMap.s.buyPrice = util.exactPointTwo(
                sellPricedetail.buyPrice
              )
              state.lstMarketDetails[
                key
              ].mdMap.s.sellPrice = util.exactPointTwo(
                sellPricedetail.sellPrice
              )
              state.lstMarketDetails[key].mdMap.s.close = util.exactPointTwo(
                sellPricedetail.close
              )
              state.lstMarketDetails[key].mdMap.s.high = util.exactPointTwo(
                sellPricedetail.high
              )
              state.lstMarketDetails[key].mdMap.s.low = util.exactPointTwo(
                sellPricedetail.low
              )
              state.lstMarketDetails[key].mdMap.s.quotechange =
                sellPricedetail.quotechange
              state.lstMarketDetails[key].mdMap.s.changePrice =
                sellPricedetail.changePrice
              state.lstMarketDetails[key].mdMap.s.open = util.exactPointTwo(
                sellPricedetail.open
              )
              state.lstMarketDetails[
                key
              ].mdMap.s.yesterClosePrice = util.exactPointTwo(
                sellPricedetail.yesterClosePrice
              )
              state.lstMarketDetails[key].mdMap.s.updateTime =
                sellPricedetail.updateTime
            }
          }
        }
      }
    }
  },
  // 中远期
  currencyDataMid(state, data) {
    state.currencyDataMid = data
    state.currentCommodityInfoMid = data
    // state.items = data;
    // state.itemsEnd = data;
  },
  itemMid(state, data) {
    state.itemMid = data
    // state.items = data;
    // state.itemsEnd = data;
  },
  updateMarketDetailsMid(state, data) {
    state.marketDetailsMid = [...data]
  },
  hqPricedetailMid(state, data) {
    state.hqPricedetailMid = data
  },
  updateCurrentContractIdMid(state, data) {
    state.currentContractIdMid = 111000017
  },
  updateTimeLineDataMid(state, data) {
    state.timeLineDataMid = [...data]
  },
  updateKLineDataMid(state, data) {
    state.kLineDataMid = [...data]
  },
  updatemarketidMid(state) {
    state.marketidMid = 1
  },
  updateOpenCloseTimeMid(state, openTime, closeTime) {
    state.openTimeMid = openTime
    state.closeTimeMid = closeTime
  },
  buyLstMid(state, data) {
    state.buyLstMid = data
  },
  sellLstMid(state, data) {
    state.sellLstMid = data
  },
  PushPriceDetailResponseMid(state, data) {
    for (const j in data) {
      if (data.hasOwnProperty(j)) {
        const pushData = data[j]
        const newpricedetail = {}
        newpricedetail.price = pushData.price // 价格
        newpricedetail.volume = pushData.volume // 成交量
        newpricedetail.ioFlag = pushData.ioFlag // 买卖方向 0 买 1 卖
        newpricedetail.occurTime = pushData.occurTime
        newpricedetail.tradeDate = '0'
        newpricedetail.contractId = pushData.contractId // 币种id
        newpricedetail.marketID = '0'
        newpricedetail.averagePrice = '0'
        newpricedetail.buyPrice = '0'
        newpricedetail.sellPrice = '0'
        newpricedetail.tickCount = '0'
        newpricedetail.itemNum = '0'
        newpricedetail.counter = '0'
        if(state.hqPricedetailMid.contractId==newpricedetail.contractId){
          const midarrnum = state.hqPricedetailMid.currentDataArray.unshift(
            newpricedetail
          )
          if (midarrnum > 300) {
            state.hqPricedetailMid.currentDataArray.pop()
          }
        }
        for (const key in state.marketDetailsMid) {
          if (state.marketDetailsMid.hasOwnProperty(key)) {
            const marketDetail = state.marketDetailsMid[key]
            if (pushData.contractId == marketDetail.symbolId) {
              state.marketDetailsMid[key].amount = pushData.allVolume
              state.marketDetailsMid[key].close = pushData.price
              state.marketDetailsMid[key].high = pushData.highPrice
              state.marketDetailsMid[key].low = pushData.lowPrice
              state.marketDetailsMid[key].quotechange = pushData.qc
            }
          }
        }
      }
    }
  },
  buyOneMid(state, data) {
    state.buyOneMid = data
  },
  sellOneMid(state, data) {
    state.sellOneMid = data
  },
  setQueryUserAccessArr(state, data) {
    state.queryUserAccessArr = data
  },
  setQueryTradeAuthArr(state, data) {
    state.queryTradeAuthArr = data
  },
  setCommodityParamList(state, data) {
    state.commodityParamList = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
